// ============================================================
// Bellek içi veri deposu
//
// Uygulamanın tamamı kiracı ağacını buradan okur. Ağacın NEREDEN
// geldiği burayı ilgilendirmez; iki kaynak var:
//
//   demo modu    → src/data/seed.js (dinamik import)
//   gerçek mod   → Firestore (src/repo/firestore-veri.js)
//
// Bu ayrım neden var: tohum veri eskiden doğrudan içe aktarılıyordu
// ve bu yüzden 46 çocuk adı, alerjileri ve 50 veli telefonu ÜRETİM
// PAKETİNE giriyordu. Paket giriş ekranından önce indiğinden, oturum
// açmayan biri bile indirip okuyabiliyordu. Daha kötüsü: gerçek bir
// kreş kaydolduğunda kendi panelinde demo kreşin çocuklarını
// görecekti, çünkü Firestore yalnızca mutasyon günlüğünü besliyordu.
//
// Depo MUTABLE ve referansı sabit. Modüller `DATA`yı bir kez içe
// aktarıp tutuyor; bu yüzden `DATA = {...}` diye yeniden atanamaz,
// yalnızca içi değiştirilebilir.
// ============================================================

export const DATA = { tenants: [] };

/** Ağacı baştan doldurur. Referans korunur — bkz. yukarıdaki not. */
export function veriYukle(tenants) {
  DATA.tenants = tenants ?? [];
  return DATA;
}

export const veriVarMi = () => DATA.tenants.length > 0;

/**
 * Bir şubenin operasyonel kaplarını tamamlar.
 *
 * Tohum veride bu alanlar hazır geliyordu; Firestore'dan yalnızca
 * çekirdek kayıtlar (sınıf, personel, öğrenci) okunuyor. Eksik kap
 * bırakmak `Object.values(t.attendance)` veya `B().messages.some()`
 * gibi çağrıları patlatır — yeni açılmış bir kreşte bunların boş
 * olması normaldir, tanımsız olması değil.
 */
export function subeKaplariniTamamla(sube) {
  sube.classes ??= [];
  sube.staff ??= [];
  sube.students ??= [];
  sube.attendance ??= {};
  sube.dailyReports ??= {};
  sube.menu ??= {};
  sube.menuNote ??= "";
  sube.events ??= [];
  sube.payments ??= [];
  sube.messages ??= [];
  sube.applications ??= [];
  return sube;
}
